module.exports = __webpack_public_path__ + "img/dd3.7729ff89.png";